var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import WixComponent from '../BaseComponents/WixComponent';
import classNames from 'classnames';

import Button from '../Backoffice/Button';
import SvgX from '../svg/X.js';

import * as styles from './MessageBoxMarketerialLayout.scss';

var MessageBoxMarketerialLayout = function (_WixComponent) {
  _inherits(MessageBoxMarketerialLayout, _WixComponent);

  function MessageBoxMarketerialLayout() {
    _classCallCheck(this, MessageBoxMarketerialLayout);

    return _possibleConstructorReturn(this, (MessageBoxMarketerialLayout.__proto__ || Object.getPrototypeOf(MessageBoxMarketerialLayout)).apply(this, arguments));
  }

  _createClass(MessageBoxMarketerialLayout, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          title = _props.title,
          content = _props.content,
          primaryButtonLabel = _props.primaryButtonLabel,
          secondaryButtonLabel = _props.secondaryButtonLabel,
          onPrimaryButtonClick = _props.onPrimaryButtonClick,
          onSecondaryButtonClick = _props.onSecondaryButtonClick,
          imageUrl = _props.imageUrl,
          onClose = _props.onClose,
          theme = _props.theme,
          imageComponent = _props.imageComponent;


      var headerClasses = classNames((_classNames = {}, _defineProperty(_classNames, styles.header, true), _defineProperty(_classNames, styles['header-' + theme], true), _classNames));

      return React.createElement(
        'div',
        { className: styles.root },
        React.createElement(
          'div',
          { className: headerClasses },
          React.createElement(
            'button',
            { className: styles.close, onClick: onClose, 'data-hook': 'close-button' },
            React.createElement(SvgX, { width: 9, height: 9, thickness: 1, color: 'white' })
          ),
          imageComponent ? React.createElement(
            'div',
            { className: styles.headerImageComponent },
            imageComponent
          ) : React.createElement(
            'div',
            { className: styles.headerImage },
            React.createElement('img', { src: imageUrl, 'data-hook': 'header-image' })
          )
        ),
        React.createElement(
          'div',
          { className: styles.title, 'data-hook': 'message-box-title' },
          title
        ),
        React.createElement(
          'div',
          { className: styles.content },
          content
        ),
        React.createElement(
          'div',
          { className: styles.buttonsContainer },
          primaryButtonLabel ? React.createElement(
            'div',
            { className: styles.primaryButtonContainer },
            React.createElement(
              Button,
              { theme: 'full' + theme, onClick: onPrimaryButtonClick, dataHook: 'primary-button' },
              primaryButtonLabel
            )
          ) : null,
          secondaryButtonLabel ? React.createElement(
            'div',
            { className: styles.secondaryButtonContainer },
            React.createElement(
              'span',
              { onClick: onSecondaryButtonClick, 'data-hook': 'secondary-button' },
              secondaryButtonLabel
            )
          ) : null
        )
      );
    }
  }]);

  return MessageBoxMarketerialLayout;
}(WixComponent);

MessageBoxMarketerialLayout.propTypes = {
  title: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired,
  primaryButtonLabel: PropTypes.string.isRequired,
  secondaryButtonLabel: PropTypes.string,
  onPrimaryButtonClick: PropTypes.func,
  onSecondaryButtonClick: PropTypes.func,
  imageUrl: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  imageComponent: PropTypes.node,
  theme: PropTypes.oneOf(['blue', 'purple'])
};

MessageBoxMarketerialLayout.defaultProps = {
  theme: 'blue'
};

export default MessageBoxMarketerialLayout;
//# sourceMappingURL=MessageBoxMarketerialLayout.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/MessageBox/MessageBoxMarketerialLayout.js